import {post} from '@/utils/request';
import {erpserver,erpplatserver,oaserver,sse_url,attendanceserver} from '@/utils/baseUrl';



//部门树
export async function getDeptTree(params) {
    return post(oaserver+'/organize/getDeptTree', params, true)
}
export async function getUserList(params) {
    return post(oaserver+'/organize/getUserList', params, true)
}
export async function getUserDetail(params) {
    return post(oaserver+'/organize/getUserDetail', params, true)
}
export async function addOrDelete(params) {
    return post(erpserver+'/intrinsically-safe-devices/addOrDelete', params, true)
}
export async function getList(params) {
    return post(erpserver+'/intrinsically-safe-devices/getList', params, true)
}


